module.exports = __webpack_public_path__ + "static/media/hibiki-otsuki-lose.1005b68b.jpg";